import React, { ReactElement } from "react";
import { gql, useMutation, MutationFunction } from "@apollo/client";
import { 
  OtpValidatePhoneMutationMutation, 
  OtpValidatePhoneMutationMutationVariables 
} from "../../../../schemaTypes";

export const otpValidatePhoneMutation = gql`
  mutation OtpValidatePhoneMutation(
    $verificationCode: String!
    $phone: String!
  ) {
    otpValidatePhone(
      verificationCode: $verificationCode
      phone: $phone
    ){
      errors{
        path
        message
      }
      message
    }
  }
`;

export interface WithOtpValidatePhone {
  otpValidatePhone: MutationFunction<
    OtpValidatePhoneMutationMutation,
    OtpValidatePhoneMutationMutationVariables
  >;
}

interface Props {
  children: (data: WithOtpValidatePhone) => ReactElement | null;
}

export const OtpValidatePhone: React.FC<Props> = ({ children }) => {
  const [mutate] = useMutation<
    OtpValidatePhoneMutationMutation,
    OtpValidatePhoneMutationMutationVariables
  >
  (otpValidatePhoneMutation);

  return children({ otpValidatePhone: mutate });
};